module.exports = __webpack_public_path__ + "img/slim.b588a1ef.png";